module.exports = __webpack_public_path__ + "bs.svg?0f30e82c7146b9138138a31810ae9e1e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/bs.svg
// module id = 1018
// module chunks = 0